var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLocationPin = function SvgIconLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 105,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    y: 0.5,
    rx: 52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M64.728 63.228 52 75.956 39.272 63.228c-7.03-7.03-7.03-18.427 0-25.456 7.03-7.03 18.426-7.03 25.456 0s7.03 18.426 0 25.456M52 54.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })));
};
export default SvgIconLocationPin;